export default __webpack_public_path__ + "static/media/logo_mark.c0a61de6.png";